import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "app", "sidebar", "overlay" ]

  connect() {
    this.openGroups = new Set()
    this.mode = localStorage.getItem("nw-sidebar-mode") || "classic"
    this.isOpen = false

    if (this.hasSidebarTarget) {
      this.sidebarTarget.querySelectorAll("[data-nw-submenu-toggle]").forEach((link) => {
        if (link.getAttribute("aria-expanded") === "true" && link.dataset.sidebarGroupParam) {
          this.openGroups.add(link.dataset.sidebarGroupParam)
        }
      })
    }

    this.syncMode()
    this.syncOpenGroups()
  }

  disconnect() {
    document.body.classList.remove("nw-sidebar-open")
  }

  syncMode() {
    if (!this.hasAppTarget) return

    this.appTarget.classList.remove(
      "nw-app--sidebar-open",
      "nw-app--sidebar-mini",
      "nw-app--sidebar-floating",
      "nw-app--sidebar-compact"
    )
    if (this.mode !== "classic") {
      this.appTarget.classList.add(`nw-app--sidebar-${this.mode}`)
    }
    if (this.isOpen) {
      this.appTarget.classList.add("nw-app--sidebar-open")
    }
    document.body.classList.toggle("nw-sidebar-open", this.isOpen)
  }

  toggle() {
    this.isOpen = !this.isOpen
    this.syncMode()
  }

  close() {
    this.isOpen = false
    this.syncMode()
  }

  toggleGroup(event) {
    event.preventDefault()
    const label = event.params.group || event.currentTarget.dataset.sidebarGroupParam
    if (!label) return

    if (this.openGroups.has(label)) {
      this.openGroups.delete(label)
    } else {
      this.openGroups.add(label)
    }
    this.syncOpenGroups()
  }

  syncOpenGroups() {
    if (!this.hasSidebarTarget) return

    this.sidebarTarget.querySelectorAll("[data-nw-submenu-toggle]").forEach((link) => {
      const label = link.dataset.sidebarGroupParam
      const expanded = this.openGroups.has(label)
      const group = link.closest("li")

      link.setAttribute("aria-expanded", expanded)
      group?.classList.toggle("nw-sidebar__item--open", expanded)
    })
  }
}
